// Module
var code = "<div class=\"upgrade-button\" ng-class=\"{'danger': isInDanger, 'success': !isInDanger}\" ng-click=\"clickedUpgrade()\" ng-if=\"canUpgrade\"> {{::message}} </div> ";
// Exports
var _module_exports = code;;
var path = 'Common/AtomicUI/UpgradeButtonAngular/UpgradeButton.ng.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;